import { EnvironmentEnum, LoggerLevelEnum } from "@/enums";
import { parseLoggerLevel } from "@/logger/level";
import { ENV } from "./common";

export const LOGGER_LEVEL: LoggerLevelEnum =
  ENV === EnvironmentEnum.PRODUCTION
    ? LoggerLevelEnum.INFO
    : (parseLoggerLevel(process.env.NEXT_PUBLIC_LOG_LEVEL) ??
      LoggerLevelEnum.INFO);
